import React from 'react';

import * as S from './styles';

import IconCheckmarkWhite from 'images/icons/checkmark-white.svg';
import Text from 'app/shared/core/Text';
import ValueConstants from 'app/shared/constants/ValueConstants';

type CheckboxProps = {
  checked?: boolean;
  className?: string;
  disabled?: boolean;
  extraWide?: boolean;
  label?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  textSize?: 'tiny' | 'sm' | 'md' | 'lg' | 'xl';
  id?: string; // Must be unique. Will lead to unexpected behavior if 2 checkboxes on a page share an id.
};

const Checkbox = ({
  checked,
  className,
  disabled = false,
  extraWide = false,
  label = '',
  onChange,
  textSize = 'sm',
  id,
}: CheckboxProps) => {
  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const { keyCode } = e;
    if (keyCode === ValueConstants.ENTER_KEYCODE && onChange) {
      onChange(e as unknown as React.ChangeEvent<HTMLInputElement>);
    }
  };

  return (
    <S.Label className={className} disabled={disabled} htmlFor={id}>
      <S.HiddenCheckbox
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        onKeyDown={onKeyDown}
        aria-label={label}
      />
      <S.StyledCheckbox checked={checked} disabled={disabled} extraWide={extraWide} hasLabel={Boolean(label)}>
        {checked && <img src={IconCheckmarkWhite} height="14px" width="14px" alt="" />}
      </S.StyledCheckbox>
      <Text size={textSize}>{label}</Text>
    </S.Label>
  );
};

export default Checkbox;
